import Typography, { TypographyProps } from '@mui/material/Typography';
import { version } from '../../../package.json';

export const AppVersion: typeof Typography = (props: TypographyProps) => (
  <Typography {...props} fontSize='0.6em'>
    {version}
  </Typography>
);
